import React from "react";
import { Navigate } from "react-router-dom";
import Auth from "../../configs/Auth";
import GuestLayout from "../../layouts/GuestLayout";
import routes from "../routesCode";

const GuestRoute = ({ children }) => {
  if (Auth.isAuthenticated()) {
    return <Navigate to={routes.projects.path} replace />;
  }

  return <GuestLayout>{children}</GuestLayout>;
};

export default GuestRoute;
